import React, { useState } from "react";
import styles from "./CSVViewer.module.css";

const CSVViewer = () => {
  const [tableData, setTableData] = useState([]);

  // Handle CSV file input
  const handleFileUpload = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) return;

    // Read the file using FileReader
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      // Parse CSV text
      const parsed = parseCSV(text);
      setTableData(parsed);
    };
    reader.readAsText(file);
  };

  // A minimal CSV parser that splits on newlines, then commas
  const parseCSV = (csvString) => {
    // Split into rows by new line
    const rows = csvString.trim().split("\n");
    // Map each row into an array of cells
    const data = rows.map((row) => {
      // Split on comma – you may need more robust logic if CSV can have commas in quotes
      return row.split(",");
    });
    return data;
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>CSV Viewer</h1>

      <div className={styles.uploadSection}>
        <label htmlFor="csvInput" className={styles.uploadLabel}>
          Upload CSV:
        </label>
        <input
          type="file"
          accept=".csv"
          id="csvInput"
          className={styles.fileInput}
          onChange={handleFileUpload}
        />
      </div>

      {tableData.length > 0 && (
        <div className={styles.tableContainer}>
          <table className={styles.csvTable}>
            <thead>
              <tr>
                {tableData[0].map((cell, index) => (
                  <th key={index} className={styles.csvHeaderCell}>
                    {cell}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.slice(1).map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td key={cellIndex} className={styles.csvCell}>
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CSVViewer;
